var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{class:{
		'overlay': true,
		[`type-${ _vm.type }`]: _vm.type,
		[`align-${ _vm.align }`]: _vm.align,
	}},[_c('div',{staticClass:"loader"},[(_vm.type === 'main')?[_c('div',{staticClass:"holder"}),_vm._m(0)]:_vm._e(),(_vm.type === 'offer-tile')?[_c('div',{staticClass:"loader-image"}),_c('div',{staticClass:"loader-text loader-text-controls"}),_c('div',{staticClass:"loader-text"}),_c('div',{staticClass:"loader-text"}),_c('div',{staticClass:"loader-text"})]:_vm._e()],2)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"circle"},[_c('div',{staticClass:"straight"}),_c('div',{staticClass:"curve"})])
}]

export { render, staticRenderFns }